export default __webpack_public_path__ + "static/media/MLNL.f6c66d5d.png";